import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import {
  PricingSchemeListContainerModel
} from '../../../../../../models/aggregates/erp/pricing-scheme/pricing-scheme-list-container.model';

@Injectable({
  providedIn: 'root'
})
export class PricingSchemeListService extends BaseApiTemplateService<PricingSchemeListContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'pricing-scheme-lists';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'pricing-scheme-lists';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'pricing-scheme-lists';
    this.httpClient = http;
  }
}